/* eslint-disable @typescript-eslint/no-explicit-any */

interface InecessaryInfoAction {
  type:
    | "syncNecessaryInfo"
    | "setConnector"
    | "setBasicInfo"
    | "user_id"
    | "logout"
    | "target_shop"
    | "source_shop";
  state: any;
}

export const necessaryInfo = (
  state: any = {},
  action: InecessaryInfoAction
): any => {
  const stateUpdate = {
    ...state,
    ...action.state,
  };
  const currentUpdate = {
    ...state,
    current: {
      ...state.current,
      ...action.state,
    },
  };
  switch (action.type) {
    case "syncNecessaryInfo":
      return stateUpdate;
    case "user_id":
      return stateUpdate;
    case "target_shop":
      return currentUpdate;
    case "source_shop":
      return currentUpdate;
    case "logout":
      return {};
    case "setConnector":
      return stateUpdate;
    case "setBasicInfo":
      return stateUpdate;
    default:
      return { ...state };
  }
};
